"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrearsFileLogKey = void 0;
exports.getArrearsFileLogKey = function (arrearsFile) {
    return arrearsFile.submissionID + ", " + arrearsFile.attachment.documentID;
};
